import React, { useState, Fragment } from "react";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import styled from "styled-components";
import { Modal } from "react-responsive-modal";

import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import Divider from "@material-ui/core/Divider";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";

import Property from "../model/property";
import { updateViFontStatus } from "../utils/vietnameseFontHelper";

import { find, get, map, isUndefined, sortBy } from "lodash";


const Button = withStyles(() => ({
  root: {
    backgroundColor: "#FFFFFF",
  },
}))(Fab);

const getImg = (i18n, languageList) => {
  let langSeleted = find(languageList, (data) => data.abbr === i18n.language);
  if (isUndefined(langSeleted) && languageList.length > 0) {
    langSeleted = find(languageList, (data) => data.abbr === "en");
    i18n.changeLanguage("en");
  }
  return get(langSeleted, "flag_url");
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: "768px",
    height: "100%",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
}));

const ButtonLanguage = (props) => {
  const { t, i18n, currentPage, showButton } = props;
  const languageList = Property.getLanguages();
  const imgLanguage = getImg(i18n, languageList);
  const [openModal, setOpenModal] = useState(false);

  const languageSize = languageList.length;

  const handleClickLanguage = () => {
    setOpenModal(!openModal);
    if (openModal) {
      const html = document.querySelector("html");
      html.style = "";
    }
  };

  const classes = useStyles();
  const handleListItemClick = (data) => {
    i18n.changeLanguage(data);
    updateViFontStatus(data);
    handleClickLanguage();
    props.onSelected(data);
  };

  const br = {
    overlay: {
      background: "none",
    },
    modal: {
      borderRadius: "16px",
      boxShadow: "0 5px 5px 0 rgba(0, 0, 0, 0.25)",
      position: "fixed",
      right: "30px",
      left: "30px",
      bottom: "50px",
      width: "768px",
    },
  };
  return (
    <Content
      id="content-button-image-language"
      display={showButton && languageSize > 1 ? "block" : "none"}>
      <ButtonImageLanguage
        id="button-image-language"
        currentPage={currentPage}
        onClick={(e) => handleClickLanguage()}>
        <Button>
          <ImageLanguage src={imgLanguage} />
        </Button>
      </ButtonImageLanguage>
      <Modal
        open={openModal}
        center
        onClose={(e) => handleClickLanguage()}
        styles={br}
        showCloseIcon={false}
        blockScroll={true}>
        <div className={classes.root}>
          <div
            style={{
              justifyContent: "space-between",
              display: "flex",
              margin: "auto 16px",
              overflowY: "auto",
            }}>
            <div style={{ fontSize: "18px" }}>{t("SELECT_LANGUAGE")}</div>
            <div>
              <CloseIcon
                onClick={(e) => handleClickLanguage()}
                fontSize="large"
                color="action"
              />
            </div>
          </div>
          <List
            component="nav"
            style={{ maxHeight: "400px", overflowY: "auto" }}
            aria-label="main mailbox folders">
            {map(sortBy(languageList, ["position", "id"]), (data, index) => {
              const abbr = get(data, "abbr");
              const name = get(data, "name");
              if (abbr === null) return null; // Skip rendering if abbr is null
              return (
                <Fragment key={index}>
                  <Divider />
                  <ListItem
                    button
                    onClick={() => handleListItemClick(abbr)}>
                    <ListItemIcon>
                      <ImageLanguage
                        src={get(data, "flag_url")}
                        onClick={(e) => handleClickLanguage()}
                      />
                    </ListItemIcon>
                    <ListItemText primary={name || abbr} />
                    {abbr === i18n.language && (
                      <div>
                        <CheckIcon fontSize="large" />
                      </div>
                    )}
                  </ListItem>
                </Fragment>
              );
            })}
          </List>
        </div>
      </Modal>
    </Content>
  );
};

export default withTranslation()(ButtonLanguage);

const ImageLanguage = styled.img`
  height: 20px;
  object-fit: cover;
`;

const ButtonImageLanguage = styled.div`
  position: fixed;
  bottom: ${(props) => (props.currentPage === "store" ? "20px" : "70px")};
  right: 20px;
`;

const Content = styled.div`
  display: ${(props) => props.display};
`;
